import axios from 'axios'
import Utils from '@/common/utils';

export default {
  search: function (request) {
    return axios.get('/api/ras/search', { params: request });
  },
  exportFile: async function (request) {
    return Utils.downloadFile('/api/ras/exportExcel', "RegistrLRAS.xlsx", request);
  },
  find: function (id) {
    return axios.get('/api/ras/find?id='+id);
  },
  findShort: function (id) {
    return axios.get('/api/ras/findShort?id='+id);
  },
  findBySnils: function (snils) {
    return axios.get('/api/ras/findBySnils?snils='+snils);
  },    
  findRepresBySnils: function (snils) {
    return axios.get('/api/ras/findRepresBySnils?snils='+snils);
  },  
  findTmpPatient: function (id) {
    return axios.get('/api/poll/findTmpPatient?id='+id);
  },
  save: function (data) {
    return axios.post('/api/ras/save', data);
  },
  updateComment: function (id, comment) {
    return axios.post('/api/ras/updateComment', {id: id, text: comment});
  },
  delete: function (request) {
    return axios.delete('/api/ras/delete', {data: request});
  },
  restore: function (id) {
    return axios.post(`/api/ras/restore/${id}`);
  },
  restorePermanently: function (id) {
    return axios.post(`/api/ras/restorePermanently/${id}`);
  },
  loadUsers: function () {
    return axios.get('/api/admin/users/search', { params: {pageNumber: 1, pageSize: -1} });
  },
  loadAddressTypes() {
    return axios.get('/api/ras/addresstypes');
  },
  loadCreatedOrg() {
    return axios.get('/api/ras/createdOrganizations');
  },
  getQrCode(id) {
    return axios.get(`/api/ras/getqrcode?id=${id}`);
  },
  findPersonsRMIS(params) {
    return axios.get('/api/import/findPersonsRMIS', { params: params });
  },
  importPersonRMIS(params) {
    return axios.get('/api/import/importPersonRMIS', { params: params });
  },
  getPmpkConclusion(patientId) {
    return axios.get(`/api/ras/pmpkconclusion?patientId=${patientId}`);
  },
  getPmpkConclusionActiveList(patientId) {
    return axios.get(`/api/ras/pmpkConclusionActiveList?patientId=${patientId}`);
  },
  importExcel: function(name, file) {
    let formData = new FormData();
    formData.append('file', file);
    return axios.post( `/api/ras/import`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
    );
  },
  updatePersonDiag(id) {
    return axios.get(`/api/import/UpdatePatientDiagnosis/${id}`, {});
  },
  patientChangeGet: function (id) {
    return axios.get('/api/patientchange/get/'+id)
  }
}
